// @ts-nocheck


import React, { Component } from 'react';

import { driverInspectionCalculationApi } from '../../../../lib/api';
import Common from './components/Common';






export default class extends Component {
  render() {
    const { location, vehiclePlanId } = this.props;
    return (
      <Common
        location={location}
        vehiclePlanId={vehiclePlanId}
        crud={driverInspectionCalculationApi}
        calcScrollY={400}
        statusField={'driverInspectionCalculationStatus'}
        title={
        'Расчет потребностей в предрейсовых/послерейсовых осмотров водителей'
        } />);


  }
}
